module.exports = __webpack_public_path__ + "static/img/welfare1.4006a8e8.jpg";